import draggable from './module/draggable'

const directives = {
  draggable
}

export default directives
